module.exports = __webpack_public_path__ + "static/media/error.52b0cf2d.svg";